import { createFileRoute } from '@tanstack/react-router';

import { apiClient } from '@/lib/api/client';
import { ApiError } from '@/lib/api/error';
import { HTTP_STATUS } from '@/lib/api/http-status';
import { getPath } from '@/lib/api/path';

import { InvitationErrorPage } from './-components/InvitationErrorPage';
import type { InvitationDetail } from './-type';

export const Route = createFileRoute('/auth/invitation/$invitationCode/')({
  errorComponent: InvitationErrorPage,
  loader: async ({ params }) => {
    const res = await apiClient.GET(
      getPath('/v2/invitations/{invitationCode}'),
      {
        params: {
          path: {
            invitationCode: params.invitationCode,
          },
        },
      },
    );

    if (!res.data) {
      const error = new ApiError(res.error);
      if (
        error.response?.statusCode === HTTP_STATUS.BAD_REQUEST ||
        error.response?.statusCode === HTTP_STATUS.NOT_FOUND
      ) {
        throw error;
      }
      throw new Error('Invitation is invalid');
    }

    return {
      invitation: {
        email: res.data.email,
        givenName: res.data.givenName,
        familyName: res.data.familyName,
        middleName: res.data.middleName,
        targetEmails: res.data.targetEmails ?? [],
      } satisfies InvitationDetail,
    };
  },
});
